import React from "react";

export default function AddProducts() {
  return <div>AddProducts</div>;
}
